import { render } from "./ShortcutModal.vue?vue&type=template&id=09173971&scoped=true"
import script from "./ShortcutModal.vue?vue&type=script&lang=js"
export * from "./ShortcutModal.vue?vue&type=script&lang=js"

import "./ShortcutModal.vue?vue&type=style&index=0&id=09173971&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09173971"]])

export default __exports__